import { useEffect, useState } from 'react';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { SCROLL_THROTTLE_TIMEOUT } from '../constants';
/** Calculate overflow tyoe */
export function useSliderOverflow(contentRef) {
    var _a = useState(''), overflow = _a[0], setOverflow = _a[1];
    var updateOverflow = useThrottle(function () {
        var newOverflow = '';
        if (!contentRef.current) {
            return newOverflow;
        }
        var contentRect = contentRef.current.getBoundingClientRect();
        var scrollLeft = contentRef.current.scrollLeft;
        var scrollWidth = contentRef.current.scrollWidth;
        var scrollRight = scrollWidth - scrollLeft - contentRect.width;
        if (scrollLeft && scrollRight) {
            newOverflow = 'both';
        }
        else if (scrollLeft) {
            newOverflow = 'left';
        }
        else if (scrollRight) {
            newOverflow = 'right';
        }
        setOverflow(newOverflow);
    }, [], SCROLL_THROTTLE_TIMEOUT, { leading: true });
    useEffect(function () {
        var contentNode = contentRef.current;
        updateOverflow();
        window.addEventListener('resize', updateOverflow);
        contentNode === null || contentNode === void 0 ? void 0 : contentNode.addEventListener('scroll', updateOverflow);
        return function () {
            window.removeEventListener('resize', updateOverflow);
            contentNode === null || contentNode === void 0 ? void 0 : contentNode.removeEventListener('scroll', updateOverflow);
        };
    }, [updateOverflow, contentRef]);
    return overflow;
}
//# sourceMappingURL=useSliderOverflow.js.map